// extracted by mini-css-extract-plugin
module.exports = {"client_review":"ClientReviewItem_client_review__UJnHe"};